import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import "./Time.css";

const TimeHero = () => {
  const navigate = useNavigate();

  return (
    <div className="time-hero-container">
      
      {/* Title */}
      <div className="time-hero-title">
        Time & Attendance
        <br />
      </div>

      {/* Subtitle */}
      <div className="time-hero-subtitle">
        Easily manage and track employee attendance through the intuitive Time Clock interface
      </div>

      {/* Button */}
      <motion.button
        whileHover={{
          scale: 1.08,
          backgroundColor: "#ffffff",
          color: "#000000",
          boxShadow: "0 0 20px rgba(255, 255, 255, 0.6)",
        }}
        whileTap={{ scale: 0.95 }}
        transition={{ duration: 0.3, ease: "easeOut" }}
        className="time-hero-button font-epilogue"
        onClick={() => navigate("/schedule-a-demo")}
      >
        Schedule a Demo
      </motion.button>

    </div>
  );
};

export default TimeHero;
